import { generateUUID } from './strings'

export const connectionId = generateUUID()
